import { useContext } from "react";
import { ComposerNarrowContext } from "./ComposerNarrowContext";

export const useComposerNarrow = () =>
  Boolean(useContext(ComposerNarrowContext));

export const useInComposerFooter = () =>
  useContext(ComposerNarrowContext) !== null;
